<template>
   <div class="modal fade" 
      id="boardFilterUser" 
      aria-hidden="true" 
      aria-labelledby="boardFilterUserLabel" 
      tabindex="-1"
      >
      <div class="modal-dialog modal-dialog-scrollable">
         <div class="modal-content bg-light">
            <div class="modal-header ps-0">
               <button 
                  id="bttReturnMdFilter"
                  class="btn btn-light btn-small tc-d-gray py-0" 
                  data-bs-target="#boardFilter" 
                  data-bs-toggle="modal"
                  :data-user-app-module-id="userAppModuleId"
                  :data-filter-user-id="filterUserId"
                  ref="bttReturnMdFilter"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                     <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                  </svg>
               </button>
               <div class="w-100 text-center">
                  <h6 class="modal-title" id="boardFilterUserLabel"><b>Seleccionar un Miembro ({{userAppModuleId}})</b></h6>
               </div>
               <button 
                  type="button" 
                  class="btn-close 
                  btn-small" 
                  data-bs-dismiss="modal" 
                  aria-label="Close" 
                  >
               </button>
            </div>
            <div class="modal-body">
               <div class="offcanvas-body row gap-1">
                  <div v-for="(user, index) in usersApp" 
                        :key="index"
                        class="mouse-on"
                        @click="getFilterUser(user.id)"
                        >
                     <div class="row">
                        <div class="col-1 px-0">
                           <userCircle :circleUser="user"/>
                        </div>
                        <div class="col-11 text-start tc-gray"
                              >
                           <b>{{user.name}}</b>
                        </div>
                     </div>
                  </div>
               </div>
               <!--
                        <div class="col-11 text-start btn-info rounded"
                        :style="{'background-color': user.bg_color, 'color': user.text_color}" 
                        :style="{'background-color': user.bg_color, 'color': user.text_color}" 
                        class="fp-onOff btn-info rounded"
                           <font-awesome-icon v-if="true" icon="check" /> 
                        @click="setLabelId(label.id)"
               -->
            </div>
         </div>
      </div>
   </div>
   <!--
   -->
</template>

<script>
import { ref, onMounted, watchEffect, nextTick } from 'vue'
//import { useStore } from 'vuex'
import WspService from "../workSpace.service";

import userCircle from '/src/components/UserCircle.vue';

export default {
   components: {
      userCircle,
   },
   setup() {

      const bttReturnMdFilter = ref(null)
      const fieldPicked = ref('')

      const filterUserId = ref(0)
      const userAppModuleId = ref(0)
      const usersApp = ref([])

      //const store = useStore()

      onMounted(() => {
         document.getElementById('boardFilterUser')
         .addEventListener('show.bs.modal', function (event) {
            let button = event.relatedTarget
            userAppModuleId.value = button.getAttribute('data-user-app-module-id')
            filterUserId.value = button.getAttribute('data-filter-user-id')
            getUsersApp(userAppModuleId.value)
         })
      })

      watchEffect(() => {
      })

      function getUsersApp(userAppModuleId) {
         WspService.getAppMembers(userAppModuleId, 0, false)
         .then(response => {
            usersApp.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getFilterUser(id) {
         filterUserId.value = id
         //bttReturnMdFilter.value.click()
         nextTick(() => { bttReturnMdFilter.value.click() })
      }

      return {
         bttReturnMdFilter,
         fieldPicked,
         filterUserId,
         getFilterUser,
         userAppModuleId, usersApp
      };
   }
}
</script>

<style scoped>
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.btn-info {
   opacity: .8;
}
.mouse-on:hover {
   cursor: pointer;
}
.btn-info:hover {
   opacity: 1;
}
</style>